import React, { Component } from "react"

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
//import { saveSubAcf2DB } from '../Tree/Utils'
//import YSpinner from  '../../elements/Spinner/Spinner'

class SettingTabs extends Component {
    constructor(props){
        super(props)
        this._isMounted = false;
        this.state = {
            cptId : this.props.cptId, // 6296, // get from props
            isLoading: true,
            isUpdating: false,
            //isOnSaveTable: false,
            terms: [],
            cpt: {},
            intake_info: [],
            intake:[],
            title: ""
        }
    }
    inUpdate = (onOff) => {
       // console.log("inUpdate =", onOff)
        if (this._isMounted)
            this.setState({isUpdating:onOff})
    }
    
    fetchTerm(url) {
        fetch(url/*, { signal: this.abortController.signal }*/)
        .then(response => {
            if (!this._isMounted) return null
            if (response.ok)
                return response.json()
            throw new Error('fetchTerm: Something went wrong ...')
        })
        .then(cpt => {             
            var terms = Object.entries(cpt['acf'])
            var title = Object.values(cpt['title'])
            var intake_info = cpt['acf']['intake_info']
            var intake = cpt['acf']['intake']
            
            if (!this._isMounted) return null
            this.setState({cpt, terms, title, intake_info, intake, isLoading: false})
            
            return (terms) // void - no one is looking...
        })//.then( () => { //FOR DEBUG PURPOSES console.log("title",this.state.cpt['title'])  })
        .catch(restError => {
            if (restError.name === 'AbortError') return; 
            if (!this._isMounted) return null
            this.setState({ restError: restError, isLoading: false })
        })
        return null
    }
    componentDidMount(){ // add constructor..
        this._isMounted = true
        //this.setState({isLoading: true  })     // modalRoot: document.getElementById('modal-root'),
        //var uri = "http://yahav/wp-json/wp/v2/digma_intakes/"+ this.state.cptId +"?fields=id,title,acf" 
        //const uri = GetIntakesEP + "/" + this.state.cptId + "?fields=id,title,acf" 
        
        //this.fetchTerm(uri)
    }
    componentWillUnmount(){ // add constructor..
        this._isMounted = false
    }
    // need id, table id & data
    render(){
        
        return(
                <div className="clear-both">
                    <Tabs  >
                        <h1 className="text-center">הגדרות אפליקציה</h1>
                        <TabList>
                            <Tab>הפניות</Tab>
                            <Tab>אינטייק </Tab>
                            <Tab>תוכנית </Tab>
                            <Tab>אחרי תוכנית </Tab>
                        </TabList>
                        <br />
                        <TabPanel >  <h2>הפניות</h2>   </TabPanel>
                        <TabPanel >  <h2>אינטייק</h2>   </TabPanel>
                        <TabPanel >  <h2>תוכנית</h2>   </TabPanel>
                        <TabPanel >  <h2>אחרי תכנית</h2>   </TabPanel>                                                                    
                    </Tabs>
                </div>
        )
    }
}

export default SettingTabs
